import React from "react";
import PropTypes from "prop-types";
import DHDialog from "./DHDialog";
import DHTextFieldSmall from "./DHTextFieldSmall";
import DHButtonDefault from "./DHButtonDefault";

class ConfirmWithQuestionDialog extends React.Component {

    constructor() {
        super();
        this.state = {};
    }

    componentDidMount() {
        this.refresh();
    }

    refresh() {
        this.setState({confirmation: "", answer: "" + Math.floor(Math.random() * 100) + 1});
    }

    sendNein() {
        this.props.callBackOnNein()
        this.refresh();
    }

    sendJa() {
        this.props.callBackOnJa();
        this.refresh();
    }

    render() {
        if( !this.props.visible ) {
            return "";
        }

        let jadisabeld = this.state.confirmation !== this.state.answer;
        const footer = (
            <div>
                <DHButtonDefault label={this.props.textJaButton ? this.props.textJaButton : "Ja"} disabled={jadisabeld} onClick={() => this.sendJa()} />
                <DHButtonDefault label={this.props.textNeinButton ? this.props.textNeinButton : "Nein"} onClick={() => this.sendNein()} className="p-button-secondary" />
            </div>
        );

        return <DHDialog onClose={() => this.props.callBackOnNein()} title={this.props.header} buttons={[]} comp={<>
            <div>
                {this.props.textOben}
            </div>
            <div style={{marginTop: "20px"}}>
                {this.props.textUnten}
            </div>
            <div style={{marginTop: "20px"}}>
                Bitte gebe zur Sicherheit folgende Zahl {this.state.answer} ein:
                <span style={{marginLeft:10}}>
                    <DHTextFieldSmall id="id-confirmation" label="" value={this.state.confirmation} onChange={(text) => this.setState({confirmation: text})}/>
                </span>
            </div>
            <div style={{marginTop: 20}}>
                {footer}
            </div>
        </>}/>
    }
}


ConfirmWithQuestionDialog.propTypes = {
    header: PropTypes.string.isRequired,
    textOben: PropTypes.string.isRequired,
    textUnten: PropTypes.string.isRequired,
    visible: PropTypes.bool.isRequired,
    callBackOnNein: PropTypes.func.isRequired,
    callBackOnJa: PropTypes.func.isRequired,
    textJaButton: PropTypes.string,
    textNeinButton: PropTypes.string,
};

export default ConfirmWithQuestionDialog;
